module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/425.41fe5807.png";